import { SearchApiResultType } from '@lighthouse/shared'

export const LINK_TARGET_OPTIONS = [
    {
        value: '_blank',
        label: '新开页面'
    },
    {
        value: '_self',
        label: '当前页打开'
    }
]

export const SEND_MSG_WX_OPTIONS = [
    {
        value: 'text',
        label: '发送文本消息'
    }
]

export const SEND_MSG_DINGTALK_OPTIONS = [
    {
        value: 'text',
        label: '发送文本消息'
    },
    {
        value: 'link',
        label: '发送链接'
    },
    {
        value: 'markdown',
        label: '发送富文本消息'
    }
    // {
    //     value: 'feedCard',
    //     label: '发送图文卡片消息',
    //     disabled: true
    // },
    // {
    //     value: 'actionCard',
    //     label: '图文展示模板卡片',
    //     disabled: true
    // },
    // {
    //     value: 'feedCard',
    //     label: '发送多图文卡片消息',
    //     disabled: true
    // }
]

export const SEND_WAY_OPTIONS = [
    {
        label: '腾讯企业邮',
        value: 'WE_COM_MAIL',
        icon: 'BrandLogoWeCom',
        iconColor: '#2883EC'
    },
    {
        label: '网易免费邮',
        value: 'NET_EASE_126_MAIL',
        icon: 'NetEasyFree',
        iconColor: '#1E7E3E'
    }
    // {
    //     label: '钉钉机器人',
    //     value: 'DING_TALK_ROBOT',
    //     icon: 'BrandLogoDingding',
    //     disabled: true
    // }
]

export const SEARCH_RESULT_TYPES = [
    { label: '文本', value: SearchApiResultType.TEXT },
    { label: '链接', value: SearchApiResultType.LINK }
]
